import { render, staticRenderFns } from "./GBProjects.vue?vue&type=template&id=319f7e7e&"
import script from "./GBProjects.vue?vue&type=script&lang=js&"
export * from "./GBProjects.vue?vue&type=script&lang=js&"
import style0 from "./GBProjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports